export function getPreviewImage(params) {
  const productionNumber = params.frames.productionNumber;
  let [frameType = "", frameColor = ""] = params.frames.imgSlug.split("%");
  let [topType = "", topSize = ""] = params.tops.imgSlug.split("%");

  topSize = topSize ? `_${topSize}` : "";

  const topImgName = `top-${topType}${topSize}-${params.sizes.imgSlug}-${params.color.imgSlug}`,
    frameImgName = `frame-${productionNumber}-${frameColor}-${params.sizes.imgSlug}`,
    shadowImgName = `frame-${productionNumber}-${params.sizes.imgSlug}-shadow`,
    backgroundImgName = "background",
    url = "/wp-content/uploads/tables";

  return {
    top: `${url}/tops/${topType}${topSize}/${topImgName}.png`,
    frame: `${url}/frames/${productionNumber}/${frameImgName}.png`,
    shadow: `${url}/frames/${productionNumber}/${shadowImgName}.png`,
    background: `${url}/${backgroundImgName}.jpg`,
  };
}
